import classNames from 'classnames';
import React from 'react';

import {
  FormControl,
  FormHelperText,
  InputAdornment,
  Input as MuiInput,
  makeStyles,
} from '@material-ui/core';

import LabelBlock from './LabelBlock';
import { useErrorStyles } from './form.styles';

const useStyles = makeStyles((theme) => ({
  input: {
    '& label': {
      transform: 'translate(0, 1.5px)',
      width: '100%',
      '& .label--required': {
        color: theme.palette.primary.main,
      },
      '& .label--icon-valid': {
        color: theme.palette.primary.main,
      },
    },
    '& .MuiInput-root': {
      backgroundColor: '#ffffff',
      border: '1px solid #999999',
      borderRadius: 4,
      marginTop: '2rem',
      padding: '2px 4px',
    },
  },
}));

type Props = {
  label?: string;
  prefix?: string;
  suffix?: string;
  name: string;
  value?: string;
  error?: string;
  required?: boolean;
  disabled?: boolean;
  touched?: boolean;
  isErrorVisible?: boolean;
  autoFocus?: boolean;
  onFocus?: (event: React.ChangeEvent<HTMLElement>) => void;
  onChange?: (event: React.ChangeEvent<HTMLElement>) => void;
  onBlur?: (event: React.ChangeEvent<HTMLElement>) => void;
  innerRef?: React.MutableRefObject<HTMLInputElement | null>;
};
type StyleProps = { hasLabel: boolean };
export const DatePicker: React.FC<Props> = (props) => {
  const {
    label,
    prefix,
    suffix,
    name,
    value,
    error,
    onChange,
    onBlur,
    onFocus,
    autoFocus,
    touched,
    isErrorVisible,
    required = true,
    disabled = false,
    innerRef,
  } = props;
  const styleProps: StyleProps = { hasLabel: !!label };
  const classes = useStyles(styleProps);
  const { errorFont, errorBlock } = useErrorStyles();

  return (
    <FormControl fullWidth className={classes.input}>
      <LabelBlock
        label={label}
        required={required}
        error={error}
        touched={touched}
        isErrorVisible={isErrorVisible}
      />
      <MuiInput
        type="date"
        name={name}
        value={value ?? ''}
        disabled={disabled}
        onBlur={onBlur}
        autoFocus={autoFocus}
        onFocus={onFocus}
        ref={innerRef}
        onChange={(event) => {
          const eventWithValue: React.ChangeEvent<
            HTMLTextAreaElement | HTMLInputElement
          > = {
            ...event,
            target: {
              ...event.target,
              name,
            },
            currentTarget: {
              ...event.currentTarget,
              name,
            },
          };
          onChange?.(eventWithValue);
        }}
        {...(prefix && {
          startAdornment: (
            <InputAdornment position="start">{prefix}</InputAdornment>
          ),
        })}
        {...(suffix && {
          endAdornment: (
            <InputAdornment position="end">{suffix}</InputAdornment>
          ),
        })}
      />
      {error && (touched || isErrorVisible) && (
        <FormHelperText className={classNames(errorFont, errorBlock)}>
          {error}
        </FormHelperText>
      )}
    </FormControl>
  );
};
